const dashboard = () => import(/* webpackPrefetch: true */ '@/views/sidasi/index.vue')

const routes = [
  {
    path: "/sidasi-dashboard",
    name: "Dashboard Sidasi",
    component: dashboard,
    meta: {
      title: "Dashboard Sidasi"
    }
  },
]

export default routes.map(route => {
    const meta = {
      all: false, 
      public: false,
      title: route.meta.title
    }
    return { ...route, meta }
  })